import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
    detectionDetialsData: any
    detectionDetialsGraphData: any
    detectionSingleSubstanceFrequencyData: any
    loaderDetectionDetialsData: boolean
    loaderSingleSubstance: boolean
    loaderDetialsGraphData: boolean
    activeLocarionRow: any
}
const initialState: InitialState = {
    detectionDetialsData:[],
    detectionDetialsGraphData:[],
    detectionSingleSubstanceFrequencyData:[],
    loaderDetectionDetialsData:false,
    loaderSingleSubstance:false,
    loaderDetialsGraphData:false,
    activeLocarionRow:"",
};
const detection = createSlice({
    name: 'detection',
    initialState,
    reducers: {
        setDetectionDetialsData: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            detectionDetialsData: action.payload,
        }),
        setDetectionSingleSubstanceFrequencyData: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            detectionSingleSubstanceFrequencyData: action.payload,
        }),
        setLoaderDetectionDetialsData: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            loaderDetectionDetialsData: action.payload,
        }),
        setLoaderSingleSubstance: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            loaderSingleSubstance: action.payload,
        }),
        setDetectionDetialsGraphData: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            detectionDetialsGraphData: action.payload,
        }),
        setLoaderDetialsGraphData: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            loaderDetialsGraphData: action.payload,
        }),
        setActiveLocarionRow: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            activeLocarionRow: action.payload,
        }),
        setMeasuremenDetectionDataNotFound: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            detectionMeasurementNotFound: action.payload,
        }),

    },    
});
export const { 
    setDetectionDetialsData, 
    setLoaderDetectionDetialsData, 
    setDetectionSingleSubstanceFrequencyData, 
    setLoaderSingleSubstance,
    setLoaderDetialsGraphData,
    setDetectionDetialsGraphData,
    setActiveLocarionRow,
    setMeasuremenDetectionDataNotFound

} = detection.actions;
export default detection.reducer;